import { useEditor } from "tldraw"
import { Toolbar } from "./Toolbar"
import { Redo, Undo, Upload } from "lucide-react"
import { useAppDispatch } from "../app/hooks"
import { saveBlob } from "../features/app/appSlice"
import { v4 as uuid } from "uuid"
import { ToolbarIconButton } from "./ToolbarButton"

export function PublishToolbar() {
  const editor = useEditor()
  const key = uuid()

  async function handlePublish() {
    await saveBlob({
      key: key,
      pageId: editor.getCurrentPageId(),
      data: editor.store.getStoreSnapshot(),
    })
    console.log("published with key", key)
  }

  return (
    <Toolbar direction="horizontal">
      <ToolbarIconButton icon={Upload} onClick={() => handlePublish()} />
    </Toolbar>
  )
}
